"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsDepartementManager", function ($q, $http, $debounce, obsUtils) {
    return {
        restrict: "A",
        scope: true,
        require: ['obsDepartementManager', 'obsMapManager'],
        controllerAs: "departementManagerCtrl",
        link: function ($scope, $el, $attrs, controllers) {

            var ctrl = controllers[0],
                mapManagerCtrl = controllers[1],
                obsConfig = $scope.observatoryConfig;

            ctrl.initialize(obsConfig, mapManagerCtrl);
        },
        controller: function ($scope) {

            var ctrl = this,
                config = null,
                mapManagerCtrl = null,
                requestCanceler = null,
                selectedId = null,
                referenceId = null,
                hoveredCommune = null;

            ctrl.initialize = function (_config, _mapManagerCtrl) {
                config = _config;
                mapManagerCtrl = _mapManagerCtrl;
                ctrl.loadReference();
                mapManagerCtrl.setViewport({
                    lat: 46.8,
                    lng: 2.25,
                    zoom: 6
                });
                startWatching();
            };

            ctrl.getConfig = function () {
                return config;
            };

            var startWatching = function () {
                $scope.$watch('viewport', function (view) {
                    ctrl.refreshData();
                }, true);

                $scope.$watch('communeParams', function () { // TODO : rename to generic
                    if ($scope.communeParams.temporalite !== "EVOLUTION" && $scope.communeParams.representation !== "RELATIF") {
                        $scope.communeParams.unite = "VALEUR";
                    }
                    ctrl.refreshData();
                }, true);
            };


            ctrl.setHoveredCommune = function (commune) {
                hoveredCommune = commune;
            };

            ctrl.getHoveredCommune = function () {
                return hoveredCommune;
            };

            /**
             *
             * @param commune
             */
            ctrl.setReferenceCommune = function (commune) {
                ctrl.loadReference(commune.id).then(function () {
                    // nothing ?
                });
            };

            ctrl.onSearchFieldSelection = function (entity) {
                if (config.publicObs) {
                    ctrl.setReferenceCommune(entity);
                } else {
                    ctrl.centerMapOn(entity);
                }
            };

            /**
             *
             */
            ctrl.centerMapOn = function (entity) {
                selectedId = entity.id;

                // pour les dom, on centre dessus
                if (entity.departement > 900) {
                    mapManagerCtrl.setViewport({
                        lat: entity.coordinates.lat,
                        lng: entity.coordinates.lng,
                        zoom: 6
                    });
                } else {
                    // pour la mertropole on centre au global sur la france métropolitaine
                    mapManagerCtrl.setViewport({
                        lat: 46.8,
                        lng: 2.25,
                        zoom: 6
                    });
                }
                // necessaire pour que la selection soit toujour redessinée
                ctrl.refreshData();

            };

            ctrl.getSelectedId = function () {
                return selectedId;
            };

            ctrl.setSelectedId = function (entityId) {
                selectedId = entityId;
            };

            /**
             * Load reference from server, either from given code insee, or defaulting to geoloc if insee is null or invalid.
             */
            ctrl.loadReference = function (refIdToLoad, centerOnMap) {
                // set empty default if none
                if ($scope.reference == null) {
                    $scope.reference = {
                        id: null,
                        name: "Pas de référence",
                        coordinates: null
                    };
                }
                // then load
                return $http.get(config.resourceBaseUrl + "/reference", {
                        params: {
                            year: $scope.communeParams.anneeInstantane,
                            id: refIdToLoad
                        }
                    }
                ).then(function (response) {
                    var reference = response.data;
                    referenceId = reference.id;
                    $scope.reference = reference;
                    if (reference.coordinates) {
                        // ne pas recentrer évite de recharger les contours, a ne faire que si les contours sont déjà là, c'est à dire sur un click de contour
                        if (centerOnMap !== false) {
                            ctrl.centerMapOn(reference);
                        }
                    }
                });
            };

            /**
             *
             */
            ctrl.refreshData = $debounce(function () {

                if (requestCanceler) {
                    requestCanceler.resolve();
                }

                requestCanceler = $q.defer();
                $scope.$broadcast("obs:data-load:start");

                var viewport = mapManagerCtrl.getViewport();
                var mapDataParams = _.extend({}, $scope.communeParams, {
                    referenceId: referenceId,
                    position: {
                        lat: viewport.lat,
                        lng: viewport.lng
                    }
                });

                $http.post(config.resourceBaseUrl + "/map-data", mapDataParams, {timeout: requestCanceler.promise}).then(function (response) {
                    var infoCommune = response.data;


                    // TODO : clean this
                    // Toujours la valeur absolue pour l'affichage de la valeur de référence
                    var formatParameters = _.extend({}, $scope.communeParams, {
                        representation: 'ABSOLU'
                    });

                    // quand on est en instantané, toujours en VALEUR pour les valeurs de ref.
                    if ($scope.communeParams.temporalite === 'INSTANTANE') {
                        formatParameters.unite = 'VALEUR';
                    }

                    $scope.referenceLabel = obsUtils.getTypeLabel(formatParameters.datatype);
                    $scope.referenceValue = obsUtils.formatValue(formatParameters, infoCommune.referenceValue);
                    $scope.departementValue = obsUtils.formatValue(formatParameters, infoCommune.departementValue);
                    $scope.departementCodeInsee = infoCommune.departementCodeInsee;

                    $scope.strateValue = obsUtils.formatValue(formatParameters, infoCommune.strateValue);
                    $scope.strate = obsUtils.getStrateLabel(infoCommune.strate);

                    $scope.paysValue = obsUtils.formatValue(formatParameters, infoCommune.paysValue);
                    // TODO : end

                    $scope.$broadcast("obs:data-load:success", infoCommune);
                });

            }, 250);

            $scope.$on("$destroy", function () {
                // cancel the currently waiting debounced call, if it exists.
                ctrl.refreshData.cancel();
                if (requestCanceler != null) {
                    requestCanceler.resolve();
                }
            });

        }
    };
});



// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/maps/departement/obsDepartementManager.js